export default __webpack_public_path__ + "static/media/secondary-math.d098cbf4.svg";